
 <p [innerHTML]="pagehtml"></p>
 <div *ngIf="isSanralRole">
<app-reports-for-sanral></app-reports-for-sanral>

</div>
<div *ngIf="isOtherAdminRole">
    <app-reports-for-admin></app-reports-for-admin>
    
    </div>